module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-partner/manage-partner.component.css
// module id = ./src/app/manage-partner/manage-partner.component.css
// module chunks = main